import React from 'react';
import { ClickableTile } from 'carbon-components-react';

export interface OptionCardItem {
  id: string;
  icon: React.ReactNode;
  title: string;
  description: string;
}

interface OptionCardGroupProps {
  options: OptionCardItem[];
  selectedId: string | null;
  onChange: (id: string) => void;
  disabledIds?: string[];
}

const DISABLED_CARD_STYLE: React.CSSProperties = {
  cursor: 'not-allowed',
  opacity: 0.5,
  pointerEvents: 'none'
};

const OptionCardGroup: React.FC<OptionCardGroupProps> = ({
  options,
  selectedId,
  onChange,
  disabledIds = []
}) => {
  return (
    <div className="option-card-group">
      {options.map((option) => {
        const isSelected = selectedId === option.id;
        const isDisabled = disabledIds.includes(option.id);
        const cardClasses = [
          'option-card-group__card',
          isSelected && 'option-card-group__card--selected',
          isDisabled && 'option-card-group__card--disabled'
        ]
          .filter(Boolean)
          .join(' ');
        const descClasses = isSelected
          ? 'option-card-group__description option-card-group__description--selected'
          : 'option-card-group__description';
        return (
          <ClickableTile
            key={option.id}
            className={cardClasses}
            style={isDisabled ? DISABLED_CARD_STYLE : undefined}
            aria-disabled={isDisabled}
            handleClick={() => {
              if (!isDisabled && !isSelected) {
                onChange(option.id);
              }
            }}
          >
            <div className="option-card-group__icon-wrapper">{option.icon}</div>
            <div>
              <div className="option-card-group__title">{option.title}</div>
              <div className={descClasses}>{option.description}</div>
            </div>
          </ClickableTile>
        );
      })}
    </div>
  );
};

export default OptionCardGroup;
